import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBucket: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bucket, trash, can"><path d="M2.75 3C2.33579 3 2 3.25184 2 3.5625V6.9375C2 7.24816 2.33579 7.5 2.75 7.5H21.25C21.6642 7.5 22 7.24816 22 6.9375V3.5625C22 3.25184 21.6642 3 21.25 3H2.75Z" fill="currentColor"/><path d="M3.58503 9L4.89613 19.4675C5.0058 20.3431 5.75016 21 6.63256 21H17.3674C18.2498 21 18.9942 20.3431 19.1039 19.4675L20.415 9H3.58503Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBucket;
